export enum StatusColor {
    GREEN = 'GREEN',
    BLACK = 'BLACK'
}
